import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Row, Col, FormGroup, Label, Input } from "reactstrap";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import TextField from "@material-ui/core/TextField";
import { cloneDeep } from "lodash";
import moment from "moment";
import Plotly from "plotly.js-dist";
import UploadData from "./UploadData";

export const Loads = (props) => {
  const [load_id, setLoad_id] = useState(null);
  const [load, setLoad] = useState(null);
  const [monthlyLoad, setMonthlyLoad] = useState({});
  const rowHeight = 24;

  useEffect(() => {
    if (load_id !== null) {
      var load_selected = cloneDeep(
        props.loads.find((obj) => {
          return String(obj.id) === String(load_id);
        })
      );
      setLoad(load_selected);
      // group by month
      var monthlyValues = {};
      load_selected.data.forEach((obj) => {
        var mo;
        if (obj.date[2] === "/") {
          mo = moment(obj.date, "DD/MM/YYYY HH:mm").format("MMMM");
        } else {
          mo = moment(obj.date, "YYYY/MM/DD HH:mm").format("MMMM");
        }
        if (monthlyValues[mo] === undefined) {
          monthlyValues[mo] = [];
        }
        monthlyValues[mo].push(obj.load);
      });
      var monthlySum = {};
      Object.keys(monthlyValues).forEach((k) => {
        var sum_MWh = monthlyValues[k].reduce((a, b) => a + b, 0) / 1000;
        monthlySum[k.substring(0, 3)] = sum_MWh;
      });
      // set chart data for Monthly values and hourly values
      setTimeout(() => {
        var charData = [
          {
            x: Object.keys(monthlySum),
            y: Object.values(monthlySum),
            type: "bar",
            hovertemplate: "Monthly Active power: %{y} MWh<extra></extra>",
          },
        ];
        // set chart layout
        var layout = {
          showlegend: false,
          margin: { t: 60, b: 25, l: 80, r: 10 },
          hovermode: "closest",
          title: {
            text: `Monthly Active Power (MWh)`,
            yref: "paper",
            y: 1.1,
            yanchor: "top",
          },
          yaxis: {
            title: {
              text: "Active power (MWh)",
              standoff: 10,
            },
          },
        };
        // make plot
        Plotly.newPlot("monthlyPlot", charData, layout, {
          displaylogo: false,
        });
        var charDataHourly = [
          {
            x: load_selected.data.map((obj, index) =>
              obj.date.replace("1950", new Date().getFullYear())
            ),
            y: load_selected.data.map((obj) => obj.load),
            type: "line",
            hovertemplate:
              "<i>Load selected</i>" + "<br>%{x}: %{y} kW<extra></extra>",
          },
        ];
        // set text to use in the x-axes ticks (and the positions)
        var tickvals = [];
        var ticktext = [];
        load_selected.data.forEach((obj, index) => {
          if (index % 500 === 0 && index > 0) {
            var date;
            if (obj.date[2] === "/") {
              date = moment(obj.date, "DD/MM/YYYY HH:mm");
            } else {
              date = moment(obj.date, "YYYY/MM/DD HH:mm");
            }
            date = `${date.format("DD")}-${date.format("MMM")}`;
            tickvals.push(index);
            ticktext.push(date);
          }
        });
        // set chart layout
        var layoutHourly = {
          showlegend: false,
          margin: { t: 25, b: 25, l: 60, r: 10 },
          hovermode: "closest",
          xaxis: {
            rangemode: "tozero",
            tickmode: "array",
            tickvals: tickvals,
            ticktext: ticktext,
            showgrid: false,
          },
          yaxis: {
            title: {
              text: "Active power (kW)",
              standoff: 10,
            },
            tickformat: ",d",
          },
        };
        // make plot
        Plotly.newPlot("hourlyPlot", charDataHourly, layoutHourly, {
          displaylogo: false,
        });
      }, 100);
    }
  }, [load_id]);

  return (
    <div style={{ padding: 20 }}>
      <h3 style={{ marginTop: 15, marginBottom: 20 }}>Loads</h3>
      <Row>
        <Col lg="10" md="10" sm="10" xs="10">
          <FormGroup>
            <Label for="loadSelect">Inspect a Load</Label>
            <Input
              type="select"
              name="select"
              id="loadSelect"
              value={
                load_id === null
                  ? ""
                  : props.loads.find((obj) => {
                      return String(obj.id) === String(load_id);
                    }).id
              }
              onChange={(e) => setLoad_id(e.target.value)}
              style={{ width: "350px" }}
            >
              <option value="" disabled>
                ...
              </option>
              {Object.keys(props.loads).length > 0
                ? props.loads.map((load) => {
                    return (
                      <option key={load.id} value={load.id}>
                        {load.name}
                      </option>
                    );
                  })
                : null}
            </Input>
          </FormGroup>
        </Col>
        <Col lg="2" md="2" sm="2" xs="2">
          <UploadData></UploadData>
        </Col>
      </Row>

      {load !== null ? (
        <div style={{ marginTop: 10, marginBottom: 10 }}>
          <Row>
            <Col
              lg="6"
              sm="12"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  width: "100%",
                  margin: "0px auto 0px auto",
                  height: "280px",
                }}
                className="ag-theme-balham"
              >
                <AgGridReact
                  defaultColDef={{
                    filter: true,
                    sortable: true,
                    resizable: true,
                    minWidth: 60,
                    maxWidth: 600,
                    flex: 1,
                    filterParams: { buttons: ["reset"] },
                    cellStyle: (params) => {
                      return { cursor: "default" };
                    },
                  }}
                  getContextMenuItems={(params) => [
                    "copy",
                    "copyWithHeaders",
                    "paste",
                    "separator",
                    {
                      name: "Export",
                      icon: '<span class="ag-icon ag-icon-save" unselectable="on" role="presentation"></span>',
                      subMenu: [
                        "csvExport",
                        {
                          name: "Excel Export (.xlsx)",
                          icon: '<span class="ag-icon ag-icon-excel" unselectable="on" role="presentation"></span>',
                          action: () => {
                            params.api.exportDataAsExcel({
                              sheetName: "Export",
                            });
                          },
                        },
                      ],
                    },
                  ]}
                  rowData={load.data}
                  getRowHeight={(params) => {
                    return rowHeight;
                  }}
                  popupParent={document.body}
                  suppressDragLeaveHidesColumns={true}
                  stopEditingWhenGridLosesFocus={true}
                  singleClickEdit={true}
                >
                  <AgGridColumn
                    field="date"
                    headerName="Date"
                    valueGetter={(params) => {
                      var date;
                      if (params.data.date[2] === "/") {
                        date = moment(params.data.date, "DD/MM/YYYY HH:mm");
                      } else {
                        date = moment(params.data.date, "YYYY/MM/DD HH:mm");
                      }
                      return `${date.format("DD")}-${date.format(
                        "MMM"
                      )} ${date.format("HH:mm")}`;
                    }}
                  />
                  <AgGridColumn
                    field="load"
                    headerName="Load (kW)"
                    filter={"agNumberColumnFilter"}
                    type={"numericColumn"}
                  />
                </AgGridReact>
              </div>
            </Col>
            <Col
              lg="6"
              sm="12"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                id="monthlyPlot"
                style={{ width: "100%", height: "100%" }}
              ></div>
            </Col>
          </Row>

          <div
            id="hourlyPlot"
            style={{ width: "100%", height: "250px", marginTop: 20 }}
          ></div>
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  loads: state.loads.loads,
});

export default connect(mapStateToProps)(Loads);
